import React from 'react';

import  NoBagDay2024  from 'views/NoBagDay2024';

const Nep2020Guildeline = () => {
  return <NoBagDay2024 />;
};

export default Nep2020Guildeline;
